var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-table2"},[_c('div',{staticClass:"table-inner"},[_c('table',[_vm._m(0),_vm._l((_vm.tableList),function(table){return _c('tr',{key:table.id},[_c('th',[_c('div',[_vm._v(_vm._s(table.th))])]),_c('td',[_c('div',{domProps:{"innerHTML":_vm._s(table.td)}})])])})],2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('th',[_vm._v("時間")]),_c('td',{staticClass:"gray"},[_vm._v("通常会員価格 ")])])
}]

export { render, staticRenderFns }